import React, { useEffect } from 'react';
import classNames from 'classnames/bind';
import {
  arrayOf, bool, func, node, number, oneOfType, string
} from 'prop-types';
import styles from './tile.module.scss';

export const Tile = (props) => {
  const {
    border, children, className, height, onMouseEnter, onMouseLeave, padding, shadow, width
  } = props;
  useEffect(() => { LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('tile.ready'); }, []);

  const tileClasses = classNames(styles.tile, className, {
    [styles['tile--bordered']]: border,
    [styles['tile--shadow']]: shadow
  });

  const inlineStyles = {
    padding: `${padding}px`,
    width: typeof width === 'number' ? `${width}px` : width,
    height: typeof height === 'number' ? `${height}px` : height,
  };

  return (
    <div
      className={tileClasses}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      style={inlineStyles}
    >
      {children}
    </div>
  );
};

Tile.propTypes = {
  border: bool,
  children: oneOfType([arrayOf(node), node]).isRequired,
  className: string,
  height: oneOfType([number, string]),
  onMouseEnter: func,
  onMouseLeave: func,
  padding: number,
  shadow: bool,
  width: oneOfType([number, string])
};

Tile.defaultProps = {
  border: false,
  className: null,
  height: 'auto',
  onMouseEnter: null,
  onMouseLeave: null,
  padding: 10,
  shadow: false,
  width: 'auto'
};

Tile.displayName = 'Tile';
